const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let loaded = false;

export function initPixel() {
  if (!PIXEL_ID || loaded) return;
  loaded = true;
  /* eslint-disable */
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
}

export function trackPageView() {
  if (window.fbq) window.fbq("track", "PageView");
}

export function trackLead(data) {
  if (window.fbq) window.fbq("track", "Lead", data || {});
}
